module.exports = __webpack_public_path__ + "img/_map_fr_montreal.7b64538c.jpg";